import { register } from 'larasnap';
import UploadManager from './UploadManager';

register(UploadManager);
